<template>
  <md-menu md-size="medium" md-align-trigger>
    <md-button
      md-menu-trigger
      :class="buttonClass"
      class="md-round"
      :disabled="!availableCatalogs.length || buttonDisabled"
    >
      <template v-if="!currentCatalogData && !buttonDisabled">Seleccionar catálogo</template>
      <template v-if="!currentCatalogData && buttonDisabled">
        <slot name="no-selected-catalog">No hay catálogo seleccionado</slot>
      </template>
      <slot
        name="button"
        :catalog="currentCatalogData"
        v-else-if="currentCatalogData"
      >{{ currentCatalogData.name }}</slot>
    </md-button>

    <md-menu-content>
      <md-menu-item
        v-for="catalog in availableCatalogs"
        :key="catalog.id"
        @click="emitInput(catalog.id)"
      >{{ catalog.name }}</md-menu-item>
    </md-menu-content>
  </md-menu>
</template>

<script>
import catalogService from "@/services/catalog";

export default {
  name: "CatalogMenu",

  props: {
    value: {
      type: Number,
      required: false,
    },
    buttonClass: {
      type: String,
    },
    buttonDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      availableCatalogs: [],
      currentCatalog: this.value,
    };
  },

  mounted() {
    this.fetchCatalogs();
  },

  methods: {
    fetchCatalogs() {
      return catalogService.fetch("services/catalogs").then((catalogs) => {
        this.availableCatalogs = catalogs;
      });
    },
    emitInput(value) {
      this.$emit("input", value);
    },
  },

  watch: {
    // currentCatalog(value) {
    //   this.$emit('input', value)
    // },
    value(catalog) {
      this.currentCatalog = catalog;
    },
    availableCatalogs(value) {
      if (!value || !value.length) {
        return;
      }
      if (!this.value && !this.buttonDisabled) {
        const catalog = value.find((c) => c.isCurrent) || value[0];
        this.emitInput(catalog.id);
      }
    },
    currentCatalogData(value) {
      if (value) {
        this.$emit("catalogDataLoaded", value);
      }
    },
  },

  computed: {
    currentCatalogData() {
      const { currentCatalog } = this;
      return this.availableCatalogs.find((c) => c.id == currentCatalog);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Catalogs/RoadConceptsAdvance/CatalogMenu.vue